import { createAppVersionChecker } from '../services/AppVersionChecker';
import { createActivityBasedTimer } from '../services/ActivityBasedTimer';

export const versioningTimer = createActivityBasedTimer();
export const appVersionChecker = createAppVersionChecker({ interval: 1000 * 60 * 10 });
